import { action, observable, set } from "mobx";

/**
 * 권한지정 Model
 */
export default class AuthorSelected {
  @observable private authorId!: string;
  @observable private authorNm!: string;
  @observable private userid!: string;
  @observable private selectYn!: boolean;

  public constructor(data?) {
    if (data == null) {
      return;
    }

    set(this, data);
  }
  public getAuthorId(): string {
    return this.authorId;
  }
  @action
  public setAuthorId(authorId: string): void {
    this.authorId = authorId;
  }

  public getAuthorNm(): string {
    return this.authorNm;
  }
  @action
  public setAuthorNm(authorNm: string): void {
    this.authorNm = authorNm;
  }

  public getUserid(): string {
    return this.userid;
  }
  @action
  public setUserid(userid: string): void {
    this.userid = userid;
  }

  public isSelectYn(): boolean {
    return this.selectYn;
  }
  @action
  public setSelectYn(selectYn: boolean): void {
    this.selectYn = selectYn;
  }
}
